import { render, staticRenderFns } from "./CabinetSubmenuItem.vue?vue&type=template&id=b70676be&scoped=true&"
import script from "./CabinetSubmenuItem.vue?vue&type=script&lang=js&"
export * from "./CabinetSubmenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CabinetSubmenuItem.vue?vue&type=style&index=0&id=b70676be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70676be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b70676be')) {
      api.createRecord('b70676be', component.options)
    } else {
      api.reload('b70676be', component.options)
    }
    module.hot.accept("./CabinetSubmenuItem.vue?vue&type=template&id=b70676be&scoped=true&", function () {
      api.rerender('b70676be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetSubmenuItem.vue"
export default component.exports